import { gql } from "@apollo/client"

export const CreateMarketer = gql`
mutation CreateMarketer($content: contentMarketer!) {
  createMarketer(content: $content) {
    id
    name
    phone
    email
    otherInfo
    store {
      id
      name
      link
      logo
      icon
      description
      address
      numberProducts
      numberOrders
      numberClients
      admin {
        id
        profilePicture
        name
        email
        phone
        role
        activation
        emailVerify
        createdAt
        updatedAt
        deletedAt
      }
      createdAt
      updatedAt
      deletedAt
    }
    marketingMethod
    commissionType
    value
    createdAt
    updatedAt
    deletedAt
  }
}
`